import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchUser, prepareUser } from '@/microfrontends/filters/shared/services/fetchUser';
import { type TUser } from '@/microfrontends/filters/shared/types/user';

import { type TThunkApi } from '../../types';

export const getUser = createAsyncThunk<TUser, void, TThunkApi>(
  'user/get',
  async (_, thunkApi) => {
    const { rejectWithValue, extra } = thunkApi;
    const subdomain = extra.custom.subdomain;

    const userResult = await fetchUser(extra, {}, { subdomain });

    return userResult.map(prepareUser).unwrapOrElse(rejectWithValue);
  },
  {
    condition: (_, thunkApi) => {
      const state = thunkApi.getState();

      return state.user.status !== 'loading';
    },
  },
);
